module.exports = __webpack_public_path__ + "img/search.50e6df26.svg";